import { useLocal } from '@/pages/dashboard/utils/customHook'

export enum PanelList {
  selectPanel = 'select',
  customizedPanel = 'customized'
}

export const CUSTOMIZED_ID = 'customized'
export const SELECT_ID = 'select'

export const SELECT_LIST = [
  {
    id: 'keyDays',
    name: 'Key Days'
  },
  {
    id: '1-7',
    name: '1-7'
  },
  {
    id: '1-14',
    name: '1-14'
  },
  {
    id: '1-30',
    name: '1-30'
  },
  {
    id: '1-90',
    name: '1-90'
  }
]

export const useConstant = () => {
  const { getLocalText } = useLocal('component_tracking_day')
  const SELECT_LIST = [
    {
      id: 'keyDays',
      name: getLocalText('key_days')
    },
    {
      id: '1-7',
      name: '1-7'
    },
    {
      id: '1-14',
      name: '1-14'
    },
    {
      id: '1-30',
      name: '1-30'
    },
    {
      id: '1-90',
      name: '1-90'
    }
  ]

  return {
    SELECT_LIST
  }
}